import AbstractComponent from './AbstractComponent';

class Video extends AbstractComponent {
  initializeBeforeEvents() {
    this.autoplay = this.$element.classList.contains('autoplay');
    super.initializeBeforeEvents();
  }
  handleIntersection([entry]) {
    if (!this.autoplay) {
      return;
    }
    if (entry.isIntersecting || entry.intersectionRatio > this.options.intersection.threshold) {
      this.$element.play();
    } else {
      this.$element.pause();
    }
  }
}

export default Video;
